import React, { useContext, useEffect, useState } from "react";
import axios from 'axios';
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import { BsArrowRight, BsExclamationCircleFill } from "react-icons/bs";
import style from "./form.module.scss";
import { TODIS_SECONDARY_BTN, TODIS_BTN_PRIMARY, TODIS_TERTIARY_BTN, TODIS_BTN_SECUNDARY, TODIS_SECONDARY_BTN_IMPORT } from "../../components/Buttons";
import { TODIS_SUCCESS_TOAST } from "../../components/Toasts";
import arrow from "../../assets/icons/arrow-white.svg";
import save from "../../assets/icons/save.svg";
import { BiSave } from "react-icons/bi";
import { BsCheck, BsDownload } from "react-icons/bs";
import check from "../../assets/icons/check.svg";
import download from "../../assets/icons/download.svg";
import TODIS_FORM_LP from './lp_form';
import TODIS_FORM_NP from './np_form';
import TODIS_FORM_NRAILS from "./nrails_form";
import TODIS_FORM_IP from "./ip_form";
import TODIS_FORM_IRAILS from './irails_form';
import TODIS_FORM_LRAILS from './lrails_form';
import TODIS_FORM_NIWW from './niww_form';
import TODIS_FORM_IIWW from './iiww_form';
import TODIS_FORM_LIWW from './liww_form';
import TODIS_FORM_NIWWPORTS from './niwwports_form';
import TODIS_FORM_LIWWPORTS from './liwwports_form';
import TODIS_FORM_IIWWPORTS from './iiwwports_form';
import TODIS_FORM_NIRPORTS from './nairports_form';
import TODIS_FORM_LIRPORTS from './lairports_form';
import TODIS_FORM_IIRPORTS from './iairports_form';
import TODIS_FORM_NSAEPORTS from './nseaports_form';
import TODIS_FORM_LSAEPORTS from './lseaports_form';
import TODIS_FORM_ISAEPORTS from './iseaports_form';
import TODIS_FORM_NFREIGHTERMINAL from './nfreighterminal_form';
import TODIS_FORM_LFREIGHTERMINAL from './lfreighterminal_form';
import TODIS_FORM_IFREIGHTERMINAL from './ifreighterminal_form';
import TODIS_FORM_NURBANNODES from './nurbannodes_form';
import TODIS_FORM_ACQUISRAIL from './acquis_form';
import TODIS_FORM_BORDERCROSSRAILS from './nbordercrossrails_form';
import TODIS_FORM_BORDERCROSSROADS from './nbordercrossroads_form';
import Swal from 'sweetalert2'
import { TODIS_NP_SCHEMA, NP_INIT } from "../../.config/form/network_performance";
import { TODIS_LP_SCHEMA, LP_INIT } from "../../.config/form/live_project_monitoring";
import { TODIS_IP_SCHEMA, IP_INIT } from "../../.config/form/implement_project_monitoring";
import { TODIS_NRAIL_SCHEMA, NRAIL_INIT } from "../../.config/form/rails_network_performance";
import { TODIS_IRAIL_SCHEMA, IRAIL_INIT } from "../../.config/form/rails_implement_project_monitoring";
import { TODIS_LRAIL_SCHEMA, LRAIL_INIT } from "../../.config/form/rails_live_project_monitoring";
import { TODIS_NSAEPORTS_SCHEMA, NSAEPORTS_INIT } from "../../.config/form/seaport_network_performance";
import { TODIS_LSAEPORTS_SCHEMA, LSAEPORTS_INIT } from "../../.config/form/seaport_live_project_monitoring";
import { TODIS_ISAEPORTS_SCHEMA, ISAEPORTS_INIT } from "../../.config/form/seaport_implement_project_monitoring";
import { TODIS_NAIRPORTS_SCHEMA, NAIRPORTS_INIT } from "../../.config/form/airport_network_performance";
import { TODIS_NIWWPORTS_SCHEMA, NIWWPORTS_INIT } from "../../.config/form/iwwports_network_performance";
import { TODIS_LIWWPORTS_SCHEMA, LIWWPORTS_INIT } from "../../.config/form/iwwports_live_project_monitoring";
import { TODIS_IIWWPORTS_SCHEMA, IIWWPORTS_INIT } from "../../.config/form/iwwports_implement_project_monitoring";
import { TODIS_NIWW_SCHEMA, NIWW_INIT } from "../../.config/form/iww_network_performance";
import { TODIS_LIWW_SCHEMA, LIWW_INIT } from "../../.config/form/iww_live_project_monitoring";
import { TODIS_IIWW_SCHEMA, IIWW_INIT } from "../../.config/form/iww_implement_project_monitoring";
import { TODIS_NFREIGHTERMINAL_SCHEMA, NFREIGHTERMINAL_INIT } from "../../.config/form/freighterminal_network_performance";
import { TODIS_LFREIGHTERMINAL_SCHEMA, LFREIGHTERMINAL_INIT } from "../../.config/form/freighterminal_live_project_monitoring";
import { TODIS_IFREIGHTERMINAL_SCHEMA, IFREIGHTERMINAL_INIT } from "../../.config/form/freighterminal_implement_project_monitoring";
import { TODIS_NURBANNODES_SCHEMA, NURBANNODES_INIT } from "../../.config/form/urban_node_network_performance";
import { TODIS_LAIRPORT_SCHEMA, LAIRPORT_INIT } from "../../.config/form/airport_live_project_monitoring";
import { TODIS_IAIRPORT_SCHEMA, IAIRPORT_INIT } from "../../.config/form/airport_implement_project_monitoring";

import { TODIS_RAILBORDERCROSS_SCHEMA, RAILBORDERCROSS_INIT } from "../../.config/form/bordercross_railways_network_performance";
import { TODIS_ROADBORDERCROSS_SCHEMA, ROADBORDERCROSS_INIT } from "../../.config/form/bordercross_roads_network_performance";

import { TODIS_ACQUIS_SCHEMA, ACQUIS_INIT } from "../../.config/form/acquis_network_performance";

import { TODIS_MODAL_DATACOLLECTION_FILL_IN } from "../../components/Modals/ModalDatacollecctionFillIn";
import { TODIS_MODAL_VALIDATE } from "../../components/Modals/ModalValidate";
import { Formik, Form } from 'formik';
import "react-datepicker/dist/react-datepicker.css";
import { DataCollectionService } from "../../HttpService/DataCollectionService";
import { useNavigate, useLocation } from "react-router-dom";
import { TODIS_MODAL_REJECT } from "../../components/Modals/ModalDicard";
import { TODIS_MODAL_RESEND } from "../../components/Modals/ModalResend";
import AuthContext from "../../auth/authContext";
import { MODAL_CONFIRM } from "../../components/Modals/ModalForm/ModalConfirm";
import { AuxiliaryService } from "../../HttpService/AuxiliaryService";
import UsersService from "../../HttpService/UsersService";
import { RequestService } from "../../HttpService/RequestService";


const FORMS = {
    //Roads
    "ROADNPM": [TODIS_FORM_NP, NP_INIT, TODIS_NP_SCHEMA, "Roads-npm", "TEN-T Road network"],
    "ROADLIVE": [TODIS_FORM_LP, LP_INIT, TODIS_LP_SCHEMA, "Roads-live", "Ongoing TEN-T road projects"],
    "ROADIMP": [TODIS_FORM_IP, IP_INIT, TODIS_IP_SCHEMA, "Roads-imp", "Finalised TEN-T road projects"],
    //Reilwais
    "RAILWAYSNPM": [TODIS_FORM_NRAILS, NRAIL_INIT, TODIS_NRAIL_SCHEMA, "Railways-npm", "TEN-T railway network"],
    "RAILWAYSLIVE": [TODIS_FORM_LRAILS, LRAIL_INIT, TODIS_LRAIL_SCHEMA, "Railways-live", "Ongoing TEN-T railway projects"],
    "RAILWAYSIMP": [TODIS_FORM_IRAILS, IRAIL_INIT, TODIS_IRAIL_SCHEMA, "Railways-imp", "Finalised TEN-T railway projects"],
    //Seaport
    "SEAPORTSNPM": [TODIS_FORM_NSAEPORTS, NSAEPORTS_INIT, TODIS_NSAEPORTS_SCHEMA, "Seaports-npm", "TEN-T seaports"],
    "SEAPORTSLIVE": [TODIS_FORM_LSAEPORTS, LSAEPORTS_INIT, TODIS_LSAEPORTS_SCHEMA, "Seaports-live", "Ongoing TEN-T seaports projects"],
    "SEAPORTSIMP": [TODIS_FORM_ISAEPORTS, ISAEPORTS_INIT, TODIS_ISAEPORTS_SCHEMA, "Seaports-imp", "Finalised TEN-T seaports projects"],
    //Airport
    "AIRPORTSNPM": [TODIS_FORM_NIRPORTS, NAIRPORTS_INIT, TODIS_NAIRPORTS_SCHEMA, "Airports-npm", "TEN-T Airports"],
    "AIRPORTSLIVE": [TODIS_FORM_LIRPORTS, LAIRPORT_INIT, TODIS_LAIRPORT_SCHEMA, "Airports-live", "Ongoing TEN-T airports projects"],
    "AIRPORTSIMP": [TODIS_FORM_IIRPORTS, IAIRPORT_INIT, TODIS_IAIRPORT_SCHEMA, "Airports-imp", "Finalised TEN-T airports projects"],
    //iwwport
    "IWWPORTSNPM": [TODIS_FORM_NIWWPORTS, NIWWPORTS_INIT, TODIS_NIWWPORTS_SCHEMA, "IwwPorts-npm", "TEN-T inland waterways ports"],
    "IWWPORTSLIVE": [TODIS_FORM_LIWWPORTS, LIWWPORTS_INIT, TODIS_LIWWPORTS_SCHEMA, "IwwPorts-live", "Ongoing TEN-T inland waterway ports projects"],
    "IWWPORTSIMP": [TODIS_FORM_IIWWPORTS, IIWWPORTS_INIT, TODIS_IIWWPORTS_SCHEMA, "IwwPorts-imp", "Finalised TEN-T inland waterway ports projects"],
    //niww
    "IWWNPM": [TODIS_FORM_NIWW, NIWW_INIT, TODIS_NIWW_SCHEMA, "Iww-npm", "TEN-T inland waterways network"],
    "IWWLIVE": [TODIS_FORM_LIWW, LIWW_INIT, TODIS_LIWW_SCHEMA, "Iww-live", "Ongoing TEN-T inland waterway projects"],
    "IWWIMP": [TODIS_FORM_IIWW, IIWW_INIT, TODIS_IIWW_SCHEMA, "Iww-imp", "Finalised TEN-T inland waterway projects"],
    //freigterminal
    "FREIGHTNPM": [TODIS_FORM_NFREIGHTERMINAL, NFREIGHTERMINAL_INIT, TODIS_NFREIGHTERMINAL_SCHEMA, "Freight-npm", "TEN-T freight terminals"],
    "FREIGHTLIVE": [TODIS_FORM_LFREIGHTERMINAL, LFREIGHTERMINAL_INIT, TODIS_LFREIGHTERMINAL_SCHEMA, "Freight-live", "Ongoing TEN-T freight terminals projects"],
    "FREIGHTIMP": [TODIS_FORM_IFREIGHTERMINAL, IFREIGHTERMINAL_INIT, TODIS_IFREIGHTERMINAL_SCHEMA, "Freight-imp", "Finalised TEN-T freight terminals projects"],
    //urban nodes
    "URBANNPM": [TODIS_FORM_NURBANNODES, NURBANNODES_INIT, TODIS_NURBANNODES_SCHEMA, "Urban-npm", "TEN-T urban nodes"],
    //border cross
    "RAILWAYSBORDERNPM": [TODIS_FORM_BORDERCROSSRAILS, RAILBORDERCROSS_INIT, TODIS_RAILBORDERCROSS_SCHEMA, "Railways-BorderCrossing-npm", "TEN-T railway border crossing"],
    "ROADSSBORDERNPM": [TODIS_FORM_BORDERCROSSROADS, ROADBORDERCROSS_INIT, TODIS_ROADBORDERCROSS_SCHEMA, "Road-BorderCrossing-npm", "TEN-T road border crossing"],
    //EUACQUIS
    "EUACQUIS": [TODIS_FORM_ACQUISRAIL, ACQUIS_INIT, TODIS_ACQUIS_SCHEMA, "EU-acquis", "EU Acquis Compliance Matrix"],
}

let isStatusRedActivated = {
    value: false,
    requestId: null,
};
export const isStatusRed = () => {
    return isStatusRedActivated.value;
};

export const activateStatusRed = (task) => {
    if ((task.roleId === 2 || task.roleId === 3) && task.statusId == 4 && (task.requestId == isStatusRedActivated.requestId || isStatusRedActivated.requestId == null)) {
        isStatusRedActivated.value = true;
        isStatusRedActivated.requestId = task.requestId;
    } else if ((task.roleId === 2 || task.roleId === 3) && task.statusId == 4 && task.requestId != isStatusRedActivated.requestId) {
        isStatusRedActivated.value = true;
        isStatusRedActivated.requestId = task.requestId;
    } else if (task.requestId != isStatusRedActivated.requestId) {
        isStatusRedActivated.value = false;
        isStatusRedActivated.requestId = task.requestId;
    }
};

const TODIS_FORM = ({ permissions, type }) => {

    let FormComponent = FORMS[type][0];

    const { user } = useContext(AuthContext);
    const [flagForm, setFlagForm] = useState(false);
    const [dataform, setDataForm] = useState(FORMS[type][1]);
    const [status, setStatus] = useState(permissions.some(item => item.id == 5) || permissions.some(item => item.id == 6))
    const [cError, setCError] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [showSave, setShowSave] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const [showvalidate, setShowValidate] = useState(false);
    const [showSubmitToast, setShowSubmitToast] = useState(false);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [showResend, setShowResend] = useState(false);
    const [triggerEffect, setTriggerEffect] = useState(false);
    const [auxState, setAuxState] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
              let response = await new RequestService(`workflow/request/history/${state.requestId}`).get();
              setAuxState(response.requestDetailsDTO.assignedBy.trim());
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          };
      
        fetchData();
        const isDataSharing = window.location.href.includes("/DataSharing");
        //setFlagForm(!isDataSharing);
        if(isDataSharing == true){
            setFlagForm(true);
        }else{
            setFlagForm(false);
        }
        //console.log("VALOR1: ", isDataSharing);
        //console.log("VALOR: ", flagForm);
      }, []);

    useEffect(() => {
        //console.log("modal: ", modalShow);
        (async () => {
            //load the form data TODO: POR MEJORAR
            // if(state.statusId == 1){
            // setDataForm({...dataform, startKm: state.requestDetailsDTO.startKm, endKm: state.requestDetailsDTO.endKm})
            // }else{
            let lstFeulType = [];
            const query = await new AuxiliaryService('auxData/typefuels').getAuxiliaries();

            query.map((option, index) => {
                lstFeulType = option.auxtableDetailsDTOList
            })

            const res = await new DataCollectionService("data/load/" + state.requestId).getFormById();
            if (res.nodeName) {
                res.nodeNameval = res.nodeName
            }
            if (res == null) {
                setDataForm({ ...dataform, startKm: state.requestDetailsDTO.startKm, endKm: state.requestDetailsDTO.endKm, routeId: state.requestDetailsDTO.routeId, regionalPartner: state.requestDetailsDTO.regionalPartner })
            } else {
                if (res.roadsNpmInfraDTO?.fuelTypeDirA != null) {
                    let listData = res.roadsNpmInfraDTO.fuelTypeDirA.trim().split(",");
                    var newValue = [];
                    listData.map(data => lstFeulType.find(item => {
                        if (item.txtDescription == data)
                            newValue.push({ value: item.idAuxtabledetail, label: item.txtDescription })
                    }));
                    //console.log(newValue)
                    res.roadsNpmInfraDTO.fuelTypeDirA = newValue
                }
                if (res.roadsNpmInfraDTO?.fuelTypeDirB != null) {
                    let listData = res.roadsNpmInfraDTO.fuelTypeDirB.trim().split(",");
                    var newValue = [];
                    listData.map(data => lstFeulType.find(item => {
                        if (item.txtDescription == data)
                            newValue.push({ value: item.idAuxtabledetail, label: item.txtDescription })
                    }));
                    //console.log(newValue)
                    res.roadsNpmInfraDTO.fuelTypeDirB = newValue
                }
                setDataForm(res)
                //console.log("res: ", res);
            }
            //load the file its EU Acquis

            // }
        })();
    }, [triggerEffect, modalShow])

    const leerdatos = (data) => {
        setDataForm(data);
    };

    const saveForm = async (values) => {
        try {
            // let url = 'data/save/'+state.requestId+ '/' + state.id + '/' + FORMS[type][3] + '/' + user.username;   
            let url = "data/save";
            if (values.liveRoadProjId) {
                delete values.liveRoadProjId;
                delete values.roadsLiveNmDTO.liveRoadProjId;
                delete values.roadsLivePmDescDTO.liveRoadProjId;
                delete values.roadsLivePmEligiTentDTO.liveRoadProjId;
                delete values.roadsLivePmPiDTO.liveRoadProjId;
                delete values.roadsLivePmIndicatorsDTO.liveRoadProjId;
                delete values.roadsLivePmStatusDTO.liveRoadProjId;
                delete values.roadsLivePmTentcompDTO.liveRoadProjId;
            }
            else if (values.npmRoadId) {

            }
            if (values.roadsNpmInfraDTO) {
                if (values.roadsNpmInfraDTO.fuelTypeDirA) {
                    values.roadsNpmInfraDTO.fuelTypeDirA = values.roadsNpmInfraDTO.fuelTypeDirA.map(item => item.label).join(",");
                }
                if (values.roadsNpmInfraDTO.fuelTypeDirB) {
                    values.roadsNpmInfraDTO.fuelTypeDirB = values.roadsNpmInfraDTO.fuelTypeDirB.map(item => item.label).join(",");
                }
            }
            // let url = 'data/save/'+state.requestId+ '/' + FORMS[type][3];
            let body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: user.username, requestForm: JSON.stringify(values) }
            //console.log(values);

            const res = await new DataCollectionService(url).createform(body);
            if (res.status > 200 && res.status < 300) {
                setShowToast(true)
                setDataForm(values)
                setTriggerEffect(prevState => !prevState);
            } else {
                console.log("Error saving form")
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getFirstErrorKey = (object, keys = []) => {
        const firstErrorKey = Object.keys(object)[0];
        if (typeof (object[firstErrorKey]) === "object") {
            return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey]);
        }
        return [...keys, firstErrorKey].join(".");
    };

    //TODO: Accept parameters
    const acceptReq = async () => { 
        try {
            let url = 'workflow/update';
            let body;
            
            if (permissions.some(item => item.id == 2))
                body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: auxState };
            else if (permissions.some(item => item.id == 5))
                body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: auxState };
            
            /*
            if (permissions.some(item => item.id == 2)){
                if(state.requestDetailsDTO.formType == 1 || state.requestDetailsDTO.formType == 2 || state.requestDetailsDTO.formType == 3){ //Airports
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 4 || state.requestDetailsDTO.formType == 5 || state.requestDetailsDTO.formType == 6){ //Freight
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 7 || state.requestDetailsDTO.formType == 8 || state.requestDetailsDTO.formType == 9){ //Iww
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 10 || state.requestDetailsDTO.formType == 11 || state.requestDetailsDTO.formType == 12){ //IwwPorts
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 13 || state.requestDetailsDTO.formType == 14 || state.requestDetailsDTO.formType == 15){ //Railways
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: "d.lasica" };
                }else if(state.requestDetailsDTO.formType == 16 || state.requestDetailsDTO.formType == 17 || state.requestDetailsDTO.formType == 18){ //Roads
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: "m.tenovici" };
                }else if(state.requestDetailsDTO.formType == 19 || state.requestDetailsDTO.formType == 20 || state.requestDetailsDTO.formType == 21){ //Seaports
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "ADMIN", assignUserId: "---" };
                }
            }else if (permissions.some(item => item.id == 5)){
                if(state.requestDetailsDTO.formType == 1 || state.requestDetailsDTO.formType == 2 || state.requestDetailsDTO.formType == 3){ //Airports
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 4 || state.requestDetailsDTO.formType == 5 || state.requestDetailsDTO.formType == 6){ //Freight
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 7 || state.requestDetailsDTO.formType == 8 || state.requestDetailsDTO.formType == 9){ //Iww
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 10 || state.requestDetailsDTO.formType == 11 || state.requestDetailsDTO.formType == 12){ //IwwPorts
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: "---" };
                }else if(state.requestDetailsDTO.formType == 13 || state.requestDetailsDTO.formType == 14 || state.requestDetailsDTO.formType == 15){ //Railways
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: "d.lasica" };
                }else if(state.requestDetailsDTO.formType == 16 || state.requestDetailsDTO.formType == 17 || state.requestDetailsDTO.formType == 18){ //Roads
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: "m.tenovici" };
                }else if(state.requestDetailsDTO.formType == 19 || state.requestDetailsDTO.formType == 20 || state.requestDetailsDTO.formType == 21){ //Seaports
                    body = { requestId: state.requestId, taskId: state.id, taskStatus: "DONE", userRole: "COORDINATOR", assignUserId: "---" };
                }
            }
            */
            const loadingSwal = Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                //showCancelButton: true,
                //cancelButtonText: 'Close',
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const res = await new DataCollectionService(url).createform(body);

            if (res.status == 200) {
                Swal.close();
                Swal.fire(
                    'You have successfully completed the task!',
                    'There is no need to resubmit it!',
                    'success'
                ).then(() => {
                    // Esperar 1 segundo antes de navegar
                    setTimeout(() => {
                        navigate("/TODIS-APP/WorkFlow/");
                    }, 1000); // 1000 milisegundos = 1 segundo
                });
            } else {
                console.log("Error accepting the form");
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred while creating the update request.',
                showConfirmButton: true
            });
            console.log("error:", error);
        }
    }

    const validDiscard = (actions) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1b59a0',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, discard it!'
        }).then((result) => {
            if (result.isConfirmed) {
                actions(dataform)
                Swal.fire(
                    'Discarded!',
                    'Your change has been discarded.',
                    'success'
                )
            }
        })
    }

    const showValidateError = (validateForm) => {
        validateForm().then(
            (errors) => {
                setCError(errors)
                setShowValidate(true)
            }
        )
    }

    //TODO: Reject parameters
    const onSubmitReject = async (values) => {
        try {
            let url = 'workflow/update';
            let body;
            if (permissions.some(item => item.id == 2))
                body = { requestId: state.requestId, taskId: state.id, taskStatus: "RESUBMIT", userRole: "ADMIN", assignUserId: state.requestDetailsDTO.assignedTo, comment: values.remarks };
            // url = 'workflow/update/'+ state.requestId+ '/' + state.id + '/RESUBMIT/ADMIN/john.doe';
            else if (permissions.some(item => item.id == 5))
                body = { requestId: state.requestId, taskId: state.id, taskStatus: "RESUBMIT", userRole: "COORDINATOR", assignUserId: state.requestDetailsDTO.assignedTo, comment: values.remarks };
            // url = 'workflow/update/'+ state.requestId+ '/' + state.id + '/RESUBMIT/COORDINATOR/john.doe';
            // else if(permissions.some(item => item.id == 5 && item.id == 2))
            //     body = {requestId: state.requestId, taskId: state.id, taskStatus: "RESUBMIT", userRole: "ADMIN", assignUserId: "john.doe", comment: values.reason + " : " + values.remarks };
            //     // url = 'workflow/update/'+ state.requestId+ '/' + state.id + '/RESUBMIT/ADMIN/john.doe';

            //console.log("rejecting data here...", body);

            const res = await new DataCollectionService(url).createform(body);
            if (res.status == 200) {
                Swal.fire(
                    'Rejected!',
                    'The data has been Rejected.',
                    'success'
                )
                setShowReject(false)
                navigate("/TODIS-APP/WorkFlow/")
            } else {
                console.log("Error rejecting the form")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSubmitSave = async (comment, valuesForm) => {
        try {
            // let url = 'data/save/'+state.requestId+ '/' + state.id + '/' + FORMS[type][3] + '/' + user.username;
            let url = "data/save";
            let fuelTypeDirATemp;
            let fuelTypeDirBTemp;
            if (valuesForm.roadsNpmInfraDTO) {
                if (valuesForm.roadsNpmInfraDTO.fuelTypeDirA) {
                    fuelTypeDirATemp = valuesForm.roadsNpmInfraDTO.fuelTypeDirA;
                    valuesForm.roadsNpmInfraDTO.fuelTypeDirA = valuesForm.roadsNpmInfraDTO.fuelTypeDirA.map(item => item.label).join(",");
                }
                if (valuesForm.roadsNpmInfraDTO.fuelTypeDirB) {
                    fuelTypeDirBTemp = valuesForm.roadsNpmInfraDTO.fuelTypeDirB;
                    valuesForm.roadsNpmInfraDTO.fuelTypeDirB = valuesForm.roadsNpmInfraDTO.fuelTypeDirB.map(item => item.label).join(",");
                }
            }
            let body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: user.username, comments: comment, requestForm: JSON.stringify(valuesForm) }
            const res = await new DataCollectionService(url).createform(body);
            if (res.status > 200 && res.status < 300) {
                setShowSave(false)
                setShowToast(true)
                if (fuelTypeDirATemp)
                    valuesForm.roadsNpmInfraDTO.fuelTypeDirA = fuelTypeDirATemp;
                if (fuelTypeDirBTemp)
                    valuesForm.roadsNpmInfraDTO.fuelTypeDirB = fuelTypeDirBTemp;
                setDataForm(valuesForm)
            } else {
                console.log("Error saving form")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const resendSubmit = async (values) => {
        Swal.fire({
            title: 'Processing...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        let url = "data/submit";
        console.log("Here I am");
        let coordinators = await new UsersService().getAllCoordinator();
        const filteredCoordinators = coordinators.data.filter(item => item.username != "john.smith");

        let body;
        if(state.requestDetailsDTO.regionalPartnar == "Serbia"){
            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Serbia")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
        }else if(state.requestDetailsDTO.regionalPartnar == "Kosovo*"){
            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Kosovo*")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
        }else if(state.requestDetailsDTO.regionalPartnar == "Albania"){
            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Albania")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
        }else if(state.requestDetailsDTO.regionalPartnar == "Bosnia and Herzegovina"){
            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Bosnia and Herzegovina")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
        }else if(state.requestDetailsDTO.regionalPartnar == "Montenegro"){
            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Montenegro")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
        }else if(state.requestDetailsDTO.regionalPartnar == "North Macedonia"){
            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "North Macedonia")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
        }else{
            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: "john.smith", comments: values.remarks, requestForm: JSON.stringify(values) }
        }
        const res = await new DataCollectionService(url).createform(body);
        if (res.status == 200 || res.status == 201) {
            Swal.close();
            setShowSubmitToast(true)
            setTimeout(async () => {
                setShowResend(false)
                navigate("/TODIS-APP/WorkFlow/")
            }, 1000)
        }
    }

    const handleImportDataClick = () => {
        //console.log(modalShow);
        setModalShow(true);
    };

    return (
        <Container fluid className={`${style.todisFormWrapper} ${"p-4"}`}>
            <Formik
                initialValues={dataform}
                enableReinitialize={true}
                validate={() => { }}
                validationSchema={FORMS[type][2]}
                onSubmit={async (values, errors) => {
                    // let url = 'data/submit/' + state.requestId + '/' + state.id + '/' + FORMS[type][3] + '/john.smith';
                    //console.log("on submission is called")
                    if (isStatusRed()) {
                        setShowResend(true)
                    }
                    else {
                        const loadingSwal = Swal.fire({
                        title: 'Processing...',
                        //text: 'Please wait while we process your request.',
                        allowOutsideClick: false,
                        //showCancelButton: true,
                        //cancelButtonText: 'Close',
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                        // upload the file here
                        if (FORMS[type][3] == "EU-acquis") {
                            let url = `https://todis.transport-community.org/api/data/upload/file/${state.requestId}/EU-acquis`;
                            //console.log("the data of the form", values);
                            let formData = new FormData();
                            formData.append('file', values.file);
                            const res = axios.post(url, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })
                                .then(() => {
                                    //   alert('File uploaded successfully!');
                                    delete values.file;
                                    delete values.tableConcordance;
                                })
                                .catch((error) => {
                                    console.log('An error occurred:', error.response.status);
                                });


                        }

                        let url = "data/submit";
                        //console.log("URL: ", url)
                        if (FORMS[type][3] == "EU-acquis") {
                            delete values.file;
                            delete values.tableConcordance;
                        }
                        // delete values.remarks;
                        let body;
                        let coordinators = await new UsersService().getAllCoordinator();
                        const filteredCoordinators = coordinators.data.filter(item => item.username != "john.smith");

                        if(state.requestDetailsDTO.regionalPartnar == "Serbia"){
                            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Serbia")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
                        }else if(state.requestDetailsDTO.regionalPartnar == "Kosovo*"){
                            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Kosovo*")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
                        }else if(state.requestDetailsDTO.regionalPartnar == "Albania"){
                            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Albania")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
                        }else if(state.requestDetailsDTO.regionalPartnar == "Bosnia and Herzegovina"){
                            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Bosnia and Herzegovina")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
                        }else if(state.requestDetailsDTO.regionalPartnar == "Montenegro"){
                            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "Montenegro")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
                        }else if(state.requestDetailsDTO.regionalPartnar == "North Macedonia"){
                            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: filteredCoordinators.find(item => item.regionalPartner == "North Macedonia")?.username, comments: values.remarks, requestForm: JSON.stringify(values) }
                        }else{
                            body = { requestId: state.requestId, taskId: state.id, formType: FORMS[type][3], coordinatorId: "john.smith", comments: values.remarks, requestForm: JSON.stringify(values) }
                        }
                        // TODO: add the parameters here

                        //console.log("Submit form", body);
                        const res = await new DataCollectionService(url).createform(body);
                        //console.log("nodename ", res.nodeNameval)
                        if (res.nodeNameval) {
                            res.nodeName = res.nodeNameval
                        }
                        if (res.status == 200 || res.status == 201) {
                            Swal.close();
                            setShowSubmitToast(true)
                            setTimeout(async () => {
                                navigate("/TODIS-APP/WorkFlow/")
                            }, 1000)
                        }
                    }
                }}>
                {({ errors, touched, values, flagForm, validateForm, handleChange, dirty, isValid, isSubmitting, handleSubmit, setFieldValue, setFieldTouched, setFieldError, resetForm }) => (
                    <>
                        <Row className="todis-form-action-panel pb-3">
                            <Col lg={4}>
                                <Stack gap={0}>
                                    <h5 className="todis-header">{FORMS[type][4]}</h5>
                                    <small className="text-muted">Task ID: {state.id}</small>
                                </Stack>
                            </Col>
                            <Col lg={8}>
                                <Row className="float-end">
                                    {
                                        permissions.some(item => item.id == 5) ?
                                            <Col lg={12} className="float-end">
                                                {permissions.some(item => item.id == 3) && <Button variant="primary" onClick={() => setShowSave(true)} className={style.todisBtnPrimary}>SAVE </Button>}
                                                {permissions.some(item => item.id == 5 || item.id == 6) && <Button variant="outline-danger" onClick={() => setShowReject(true)} className={style.todisBtnOutline}>REJECT </Button>}
                                                {permissions.some(item => item.id == 5 || item.id == 6) && <Button variant="success" className={style.todisActionBtn} type="submit" onClick={() => acceptReq()}>
                                                    ACCEPT
                                                    <BsArrowRight className="mx-3" fontSize={18} />
                                                </Button>}
                                            </Col>
                                            :
                                            <>
                                                {/* {permissions.some(item => item.id == 3) && <Col lg={3} className="w-auto">
                                                    <TODIS_BTN_PRIMARY title="Save" icon={BiSave} onclick={() => saveForm(values)} />
                                                </Col>} */}
                                                {permissions.some(item => item.id == 3) &&
                                                    <Col lg={3} className="w-auto">
                                                        <TODIS_BTN_PRIMARY
                                                            title="Save"
                                                            icon={BiSave}
                                                            onclick={() => saveForm(values)}
                                                            tooltipText="Click here to save the form"
                                                        />
                                                    </Col>
                                                }
                                                {permissions.some(item => item.id == 3) && <Col lg={3} className="w-auto">
                                                    <TODIS_BTN_SECUNDARY title="Validate" icon={BsCheck} onclick={() => showValidateError(validateForm)} className={"w-100"} tooltipText="Click here to validate the form" />
                                                </Col>}
                                                {permissions.some(item => item.id == 3) && <Col lg={4} className="w-auto">
                                                    <TODIS_SECONDARY_BTN
                                                        title="Import Data"
                                                        iconName="save"
                                                        onclick={handleImportDataClick}
                                                        className="w-100"
                                                    />
                                                </Col>}
                                            </>
                                    }
                                </Row>
                            </Col>
                        </Row>

                        {/* <Form className="todis-form-content" onSubmit={handleSubmit} method="post">
                            <FormComponent errors={errors} touched={touched} status={false} setFieldValue={setFieldValue} values={values} dataFromForm={dataform} requestId={state.requestId}/>
                            {
                                !permissions.some(item => item.id == 5) &&
                                <div className="todis-action-form">
                                    {permissions.some(item => item.id == 3) && <Button variant="outline-primary" onClick={() => validDiscard(resetForm)} className="todis-reset-btn">DISCARD </Button>}
                                    {permissions.some(item => item.id == 3) && <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{margin: "0.5rem"}}  type="submit">SUBMIT <img src={arrow} width="15" className="todis-icon-btn" alt="submit" /></Button>}
                                </div> 
                            }

                            { modalShow && <TODIS_MODAL_DATACOLLECTION getllenarform={leerdatos} show={modalShow} onHide={() => setModalShow(false)} /> }
                            { showvalidate && <TODIS_MODAL_VALIDATE errors={cError} show={showvalidate} onHide={() => setShowValidate(false)} /> }
                            { showReject && <TODIS_MODAL_REJECT title={"Reject Data"} show={showReject} onHide={() => setShowReject(false)} onReject={onSubmitReject} /> }
                            { showToast && <TODIS_SUCCESS_TOAST show={showToast} onclosing={() => setShowToast(false)} message="Your work has been saved successfully!" title="save" image="/assets/icons/check.svg" /> }
                            { showSubmitToast && <TODIS_SUCCESS_TOAST show={showSubmitToast} onclosing={() => setShowSubmitToast(false)} message="You have successfully submitted the request!" title="save" image="/assets/icons/check.svg" />}
                            { showSave && <MODAL_CONFIRM show={showSave} onHide={() => setShowSave(false)} onSubmit={onSubmitSave} dataForm={values} /> }
                            { showResend && <TODIS_MODAL_RESEND title={"Resubmit information"} show={showResend} onHide={() => setShowResend(false)} onSubmit={resendSubmit} dataForm={values} /> }
                        </Form> */}

                        <Form className="todis-form-content" onSubmit={handleSubmit} method="post" style={{ display: 'flex', flexDirection: 'column', position: 'relative', minHeight: '100vh' }}>
                            <div style={{ flex: 1 }}>
                                <FormComponent errors={errors} touched={touched} status={false} setFieldValue={setFieldValue} values={values} dataFromForm={dataform} requestId={state.requestId} flagForm={flagForm} />
                            </div>
                            {
                                !permissions.some(item => item.id === 5) &&
                                <div className="todis-action-form" style={{ position: 'sticky', bottom: 0, right: 0, alignSelf: 'flex-end' }}>
                                    {permissions.some(item => item.id === 3) && <Button variant="outline-primary" onClick={() => validDiscard(resetForm)} className="todis-reset-btn">DISCARD </Button>}
                                    {permissions.some(item => item.id === 3) && <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{ margin: "0.5rem" }}  type="submit">SUBMIT <img src={arrow} width="15" className="todis-icon-btn" alt="submit" /></Button>}
                                </div>
                            }

                            {modalShow && <TODIS_MODAL_DATACOLLECTION_FILL_IN task={state} getllenarform={leerdatos} show={modalShow} onHide={() => setModalShow(false)} />}
                            {showvalidate && <TODIS_MODAL_VALIDATE errors={cError} show={showvalidate} onHide={() => setShowValidate(false)} />}
                            {showReject && <TODIS_MODAL_REJECT title={"Reject Data"} show={showReject} onHide={() => setShowReject(false)} onReject={onSubmitReject} />}
                            {showToast && <TODIS_SUCCESS_TOAST show={showToast} onclosing={() => setShowToast(false)} message="Your work has been saved successfully!" title="save" image="/assets/icons/check.svg" />}
                            {showSubmitToast && <TODIS_SUCCESS_TOAST show={showSubmitToast} onclosing={() => setShowSubmitToast(false)} message="You have successfully submitted the request!" title="save" image="/assets/icons/check.svg" />}
                            {showSave && <MODAL_CONFIRM show={showSave} onHide={() => setShowSave(false)} onSubmit={onSubmitSave} dataForm={values} />}
                            {showResend && <TODIS_MODAL_RESEND title={"Resubmit information"} show={showResend} onHide={() => setShowResend(false)} onSubmit={resendSubmit} dataForm={values} />}
                        </Form>

                    </>
                )}
            </Formik>
        </Container >
    )
}

export default TODIS_FORM;